<template>

  <div class="tes-comment" :style="`--level: ${level * 3};`" :data-id="item?.id()">
    <div class="tes-comment__indent"></div>
    <div class="tes-comment__content">
      <div class="tes-comment__header">
        <picture class="tes-comment__picture tes-picture__wrapper" v-if="item?.avatar()">
          <img :src="item?.avatar()?.src()" :width="item?.avatar()?.size().width()"
               :height="item?.avatar()?.size().height()"
               :alt="`avatar ${item?.name()}`"
               class="tes-comment__picture-image tes-picture__image">
        </picture>
        <picture class="tes-comment__picture tes-picture__wrapper" v-else>
          <source srcset="/src/assets/img/avatar.png?webp" type="image/webp"/>
          <img src="/src/assets/img/avatar.png" :width="65" :height="65"
               :alt="`avatar ${item?.name()}`"
               class="tes-comment__picture-image tes-picture__image">
        </picture>
        <span>
            <span class="tes-comment__name">{{ item?.name() }}</span>
            <span class="tes-comment__published">{{ item?.publishedAt()?.toLocaleDateString('ru') }}</span>
          </span>
      </div>
      <p v-html="item?.message()" class="tes-comment__message"></p>
      <button type="button" class="tes-comment__reply-button" @click="answer(item?.id()??0)" :id="`created_${ownerType}_${ownerId}_${item?.id()}`">
        <ReplyIcon style="max-width: 12px;"/> Ответить
      </button>
    </div>
    <div :id="`tt_${ownerType}_${ownerId}_${item?.id()}`" class="tes-comment__reply-teleport"></div>
  </div>

  <CommentView :level="level + 1"
               :ownerType="ownerType"
               :ownerId="ownerId"
               :item="subItem"
               :items="items"
               @answer="answer"
               v-for="subItem in items[item?.id()??0]"
               v-if="typeof items[item?.id()??0] !== 'undefined'"/>

</template>

<script lang="ts">
import {CommentInterface} from '../../objects/comment/Comment'
import {PropType} from 'vue'

import ReplyIcon from '~/assets/icons/reply.svg'


export default {
  name: 'CommentView',
  components: {ReplyIcon},
  props: {
    item: {
      type: Object as PropType<CommentInterface>,
      require: true
    },
    level: {
      type: Number,
      default: 0
    },
    items: {
      type: Array as PropType<{[p:number]:Array<CommentInterface>}>,
      default: []
    },
    ownerType: {
      type: String,
      require: true
    },
    ownerId: {
      type: Number,
      require: true
    },
  },
  emits: ['answer'],
  setup(props, {emit}) {
    const answer = (id: number) => {
      emit('answer', id)
    }
    return {answer}
  }
}
</script>
